import { createStore } from '@orderx/lab/xr/store';

export enum Currency {
    EUR = 'EUR',
    NOK = 'NOK',
    SEK = 'SEK',
    DKK = 'DKK',
}

const { useStore } = createStore<Currency | string>(Currency.EUR);

const numberFormat = {
    [Currency.EUR]: new Intl.NumberFormat('et', {
        style: 'currency',
        currency: Currency.EUR,
        minimumFractionDigits: 2,
    }),
    [Currency.NOK]: new Intl.NumberFormat('nb', {
        style: 'currency',
        currency: Currency.NOK,
        minimumFractionDigits: 0,
    }),
    [Currency.DKK]: new Intl.NumberFormat('dk', {
        style: 'currency',
        currency: Currency.DKK,
        minimumFractionDigits: 2,
    }),
};

export function useCurrency(hookCurrency?: any) {
    const [_currency, _setCurrency] = useStore();
    const { format } = numberFormat[hookCurrency || _currency];

    function toNumber(number: number, currency?: any) {
        number = number || 0;

        const roundToInteger = [Currency.NOK, Currency.SEK, Currency.DKK].includes(
            currency || hookCurrency || _currency,
        );

        if (roundToInteger) {
            return Math.round(number / 100) * 100;
        } else {
            return number;
        }
    }

    function formatToValue(number, currency?) {
        const formatFunction = numberFormat[currency || hookCurrency || _currency]?.format || format;
        return formatFunction(toNumber(number, currency) / 100);
    }

    return {
        toNumber: (amount: number, currency?: any) => toNumber(amount, currency),
        setCurrency: _setCurrency,
        format: formatToValue,
        calculateDiscount(amount: number, percent: number, currency?) {
            const value = Math.round(amount - amount * (percent / 100));
            return toNumber(value, currency);
        },
        createCurrencyFormatter(currency?) {
            return (amount: number) => formatToValue(amount, currency);
        },
        formatDecimal(amount: number, currency) {
            const value = (amount || 0) / 100;
            const formatter = numberFormat[currency];

            if (formatter) {
                return formatter.format(value);
            }

            return value;
        },
    };
}
